module.exports = require('./helpers/bundle-url').getBundleURL('dL7uY') + "logo.c51670a8.svg";